import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React, { forwardRef } from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import { viewports } from '../helper';
import config, { renderMediaQueries } from './config';
import ScopedCssBaseline from '../StyleBase/ScopedCssBaseline';

var resolveGutter = function resolveGutter() {
  return renderMediaQueries(function (dimension) {
    var gutterWidth = parseFloat(config.gutterWidth[dimension]) / 2;
    return css(["padding-right:", "px;padding-left:", "px;"], gutterWidth, gutterWidth);
  });
};

var resolveOffset = function resolveOffset(offset) {
  return renderMediaQueries(function (dimension) {
    if (typeof offset === 'number') {
      return css(["margin-left:", "%;"], offset / config.columns[dimension] * 100);
    }

    var size = offset[dimension] === undefined || offset[dimension] < 0 ? 0 : offset[dimension];
    var margin = size / config.columns[dimension] * 100;
    return css(["margin-left:", "%;"], margin);
  });
};

var resolveGrid = function resolveGrid(props) {
  var nextColumnNumber;
  return renderMediaQueries(function (dimension) {
    var columnNumber = props[dimension] || nextColumnNumber;

    if (!columnNumber) {
      return css(["flex-basis:auto;max-width:none;"]);
    }

    var percent = parseFloat(columnNumber / config.columns[dimension]) * 100;
    nextColumnNumber = columnNumber;
    return css(["flex:1 1 ", "%;max-width:", "%;"], percent, percent);
  });
};

var Root = styled.div.withConfig({
  displayName: "GridColumn__Root",
  componentId: "sc-1mru928-0"
})(["", " flex:1 0 auto;max-width:100%;", " ", " ", ""], ScopedCssBaseline, function (props) {
  return resolveGrid(props);
}, function (_ref2) {
  var withoutGutter = _ref2.withoutGutter;
  return !withoutGutter && resolveGutter();
}, function (_ref3) {
  var sizeOffset = _ref3.sizeOffset;
  return sizeOffset && resolveOffset(sizeOffset);
});
var GridColumn =
/*#__PURE__*/
forwardRef(function (_ref, ref) {
  var offset = _ref.offset,
      children = _ref.children,
      rest = _objectWithoutPropertiesLoose(_ref, ["offset", "children"]);

  return (
    /*#__PURE__*/
    React.createElement(Root, _extends({}, rest, {
      ref: ref,
      sizeOffset: offset
    }), children)
  );
});
GridColumn.viewports = {
  smallMobile: viewports.smallMobile,
  mobile: viewports.mobile,
  tablet: viewports.tablet,
  desktop: viewports.desktop,
  largeDesktop: viewports.largeDesktop
};
GridColumn.defaultProps = {
  smallMobile: null,
  mobile: null,
  tablet: null,
  desktop: null,
  largeDesktop: null,
  offset: {},
  withoutGutter: false,
  children: null,
  debug: false
};
GridColumn.propTypes = {
  /**
   * sets the number of columns on screens smallMobile
   */
  smallMobile: PropTypes.oneOf([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),

  /**
   * sets the number of columns on screens mobile
   */
  mobile: PropTypes.oneOf([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),

  /**
   * sets the number of columns on screens tablet
   */
  tablet: PropTypes.oneOf([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),

  /**
   * sets the number of columns on screens desktop
   */
  desktop: PropTypes.oneOf([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),

  /**
   * sets the number of columns on screens largeDesktop
   */
  largeDesktop: PropTypes.oneOf([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),

  /**
   * sets the number of the offset columns
   */
  offset: PropTypes.oneOfType([PropTypes.number, PropTypes.object]),

  /**
   * removes the gutter
   */
  withoutGutter: PropTypes.bool,

  /**
   * content
   */
  children: PropTypes.node
};
export default GridColumn;